var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import Box from "@cloudscape-design/components/box";
import byteSize from "byte-size";
export var SizeCell = function (_a) {
    var _b, _c;
    var file = _a.file;
    return (_jsx(Box, __assign({ variant: "p" }, { children: file.type === "file" && !isNaN(Number((_b = file.size) === null || _b === void 0 ? void 0 : _b.toString()))
            ? // if file.size is undefined, isNaN will return true.
                byteSize(Number((_c = file.size) === null || _c === void 0 ? void 0 : _c.toString())).toString()
            : "-" })));
};
export default SizeCell;
